var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cdu-component" },
    [
      _vm.brand_white1
        ? [
            !_vm.brand_translux5
              ? _c("headlines", {
                  staticClass: "background-sport bg1",
                  class: _vm.backgroundSport1,
                  attrs: {
                    category: "CDU_BACKGROUND_" + _vm.backgroundSport1,
                    isplain: true
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.brand_translux5
              ? _c("headlines", {
                  staticClass: "background-sport bg2",
                  class: _vm.backgroundSport2,
                  attrs: {
                    category: "CDU_BACKGROUND_" + _vm.backgroundSport2,
                    isplain: true
                  }
                })
              : _vm._e()
          ]
        : [
            !_vm.brand_translux5
              ? _c("headlines", {
                  attrs: {
                    category: "CDU_BACKGROUND_" + _vm.screenId.toUpperCase(),
                    isplain: true
                  }
                })
              : _vm._e()
          ],
      _vm._v(" "),
      !_vm.brand_translux4 ? _c("cdu-header") : _vm._e(),
      _vm._v(" "),
      _c("cdu-events"),
      _vm._v(" "),
      _vm.brand_translux4 ? _c("cdu-header") : _vm._e(),
      _vm._v(" "),
      _vm.showHeadlinesOnCurrentScreen && _vm.showHeadlinesLines > 0
        ? _c("headlines", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.maxRotationIndex === _vm.currentRotateIndex,
                expression: "maxRotationIndex === currentRotateIndex"
              }
            ],
            attrs: {
              category:
                "CDU_" + _vm.screenId + "_" + _vm.showHeadlinesLines + "_LINES",
              isplain: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.brand_ultrawide
        ? _c("carousel", {
            attrs: {
              category: "CDU_BACKGROUND_ULTRAWIDE_" + _vm.screenId,
              fullscreen: ""
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cduState === "banner" ? _c("banner") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67cfcee9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cfcee9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Cdu.vue
// module id = null
// module chunks = 